import { Datacenters } from '../types/Datacenters';

export const datacenters: Datacenters = {
  failed: false,
  fetching: true,
  items: []
};

export const initialVCenter = {
  vCenterName: '',
  vCenterHost: '',
  vcUsername: '',
  vcPassword: '',
  vcUsedAs: 'MANAGEMENT'
};
